import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Attribute from './layout/attribute';
import Control from './layout/control';
import Preview from './layout/preview';
import { outClick } from '@/util/util';
import { rules } from './rule';
export default {
  props: {
    // 初始化表格数据
    form: {
      default: function _default() {
        return [];
      }
    },
    // 审批流名称 取自基础信息
    title: {
      default: ''
    }
  },
  components: {
    Attribute: Attribute,
    Control: Control,
    Preview: Preview
  },
  data: function data() {
    return {
      // 当前选中组件数据
      activeData: '',
      // 组件注销之前移除全局监听函数
      fn: '',
      // 以抽屉的方式展示选中组件详情
      isViewCtrl: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    outClick.prototype.remove(this.fn);
  },
  mounted: function mounted() {
    var _this = this;
    // State 为真则点击了区域之外
    // 区域之外点击则关闭属性配置栏
    this.fn = outClick(['preview-item-box', 'custom-form-control', 'el-dialog__wrapper'], function (state) {
      _this.isViewCtrl = !state;
      if (state) {
        _this.activeData = '';
        _this.$refs.preview.currentCom = '';
        _this.doSubmit();
      }
    });
  },
  methods: {
    // 展示or隐藏（属性栏）
    handleChangeViewCtrl: function handleChangeViewCtrl(bool) {
      this.isViewCtrl = bool;
      this.doSubmit();
    },
    // 获取选中项数据
    handleActive: function handleActive(params) {
      var _this2 = this;
      this.activeData = '';
      this.$nextTick(function () {
        _this2.activeData = params;
      });
    },
    // 校验函数
    ruleCallBack: function ruleCallBack(result) {
      return !(result instanceof Error);
    },
    // 下一步之前校验
    doSubmit: function doSubmit() {
      var _this3 = this;
      var state = true;
      this.form.map(function (item) {
        var attribute = item.attribute;
        var keys = Object.keys(attribute);
        var cState = keys.some(function (el) {
          var cRules = rules[el];
          var value = item['attribute'][el];
          // 首先分不需要校验的
          if (!cRules) return false;
          var rule = cRules[0];
          var valid = false;
          // 普通校验
          if (rule.required) {
            valid = Boolean(value);
          }
          if (rule.validator) {
            valid = rule.validator(false, value, _this3.ruleCallBack);
          }
          // 自定义校验
          item.rule = valid;
          return !valid;
        });
        if (cState && state) state = false;
        return cState;
      });
      return state;
    }
  }
};